module.exports = __webpack_public_path__ + "static/flags/VE-2b66e060ad5c03eee01c0800ab2098d5.gif";